<template>
  <div
    class="transition-all duration-300"
    :style="{ height: period.element.height }"
  >
    <div
      v-if="period.is_booked === false"
      class="h-full border rounded px-1.5 pt-1.5 flex flex-col justify-center gap-1 transition-all duration-300 cursor-pointer"
      :class="{
        'pointer-events-none opacity-25':
          !currentUser.role.includes('admin') || period.disabled,
        'pointer-events-none': period.readOnly,
        'hover:bg-hover-state':
          !isSelected && !period.disabled && !period.readOnly
      }"
      :style="{
        height: period.element.height,
        backgroundColor: period.element.backgroundColor,
        borderColor: period.element.borderColor
      }"
      title="Select avaialability"
      @click="onSelect"
    >
      <BlTextBody2
        :text="`${period.start_time_string} - ${period.end_time_string}`"
        :style="{
          color:
            isSelected && !period.disabled
              ? period.secondary_color
              : period.primary_color
        }"
      />
    </div>

    <div
      v-if="period.is_booked"
      class="relative h-full border rounded px-1.5 transition-all duration-300 opacity-25"
      :class="{
        'border-dashed': period.appointment.status.includes('booking'),
        'pt-2': isCompact && period.count === 1,
        'pt-1.5': !isCompact || period.count > 1
      }"
      :style="{
        height: period.element.height,
        backgroundColor: period.element.backgroundColor,
        borderColor: period.element.borderColor
      }"
    >
      <div
        class="h-full flex gap-1"
        :class="{
          'items-center justify-between': isCompact && period.count === 1,
          'flex-col justify-center': !isCompact || period.count > 1
        }"
      >
        <BlTextBody2
          v-if="
            isOpenRoom &&
              period.appointment.user &&
              period.appointment.user.name &&
              (!isCompact || period.count > 1)
          "
          :text="period.appointment.user.name"
          :style="{ color: period.appointment.primary_color }"
          class="truncate"
        />
        <BlTextSubtitle3
          v-if="period.appointment.client && period.appointment.client.name"
          :text="period.appointment.client.name"
          :style="{ color: period.appointment.primary_color }"
          class="truncate"
        />
        <BlTextBody2
          v-if="isCompact && period.count === 1"
          :text="period.appointment.start_time_string"
          :style="{ color: period.appointment.primary_color }"
        />
        <BlTextBody2
          v-if="!isCompact || period.count > 1"
          :text="
            `${period.appointment.start_time_string} - ${period.appointment.end_time_string}`
          "
          :style="{ color: period.appointment.primary_color }"
        />
        <BlTextBody2
          v-if="!isCompact && enableBranch && period.appointment.room.branch"
          :text="period.appointment.room.branch.name"
          :style="{ color: period.appointment.primary_color }"
          class="truncate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTextBody3 from "../../BlTextBody3.vue";
import BlIcon from "../../BlIcon.vue";

export default {
  name: "Period",
  components: {
    BlTextSubtitle3,
    BlTextBody2,
    BlTextBody3,
    BlIcon
  },
  props: {
    isCompact: { type: Boolean, default: false },
    slotHeight: { type: Number, required: true },
    item: { type: Object, required: true },
    therapist: { type: Object, default: null },
    room: { type: Object, default: null },
    isSelected: { type: Boolean, default: false },
    isOpenRoom: { type: Boolean, default: false }
    // @set-selected
  },
  data() {
    return {
      newAppointmentOpened: false,
      detailsOpened: false,
      rescheduleOpened: false,
      cancelOpened: false,
      appointmentLoading: false,
      appointmentDetails: null
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter"]),
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    dataId() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let combination = "";
      for (let i = 0; i < 6; i++) {
        combination += chars[Math.round(Math.random() * 35)];
      }
      return `bl-appointment-details-${combination}`;
    },
    period() {
      const item = { ...this.item };
      const element = {
        height: ``,
        backgroundColor: "",
        borderColor: item.secondary_color
      };

      const slot = this.slotHeight * item.count;
      const space = 0.25 * (item.count - 1);
      element.height = `calc(${slot}rem + ${space}rem)`;

      if (item.is_booked) {
        element.backgroundColor = item.appointment.secondary_color;
        if (item.appointment.status.includes("booking")) {
          element.borderColor = item.primary_color;
        }
      }

      if (this.isSelected && !item.disabled && !item.is_booked) {
        element.backgroundColor = item.primary_color;
      }

      const startDate = item.date;
      return { ...item, element, start_date: startDate };
    }
  },
  watch: {
    detailsOpened(val) {
      if (val) {
        setTimeout(() => {
          window.addEventListener("click", this.closeHandler);
        }, 10);
      }
    }
  },
  mounted() {},
  methods: {
    ...mapActions([""]),
    displayDate(date, format = "dddd, DD MMM YYYY") {
      return moment(date).format(format);
    },
    getSlotCount(start, end) {
      const s = start.split(":").map(i => Number(i));
      const e = end.split(":").map(i => Number(i));
      let slots = 0;
      slots += (e[0] - s[0]) * 2;
      if (s[1] === 30) slots -= 1;
      if (e[1] === 30) slots += 1;
      return slots;
    },
    onSelect() {
      this.$emit("set-selected");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/appointments/overlapped/Period.vue